import { put, call, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Action
import { loadingSet } from '../action/uiAction';


function* myQaAnswerListGet(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function (payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('page', payload.page);
    return axios.post(config.apiUri + "member/myQaAnswerListApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool) {
      yield put({
        type: "MY_QA_ANSWER_LIST_SET",
        payload: {
          list: res.data.list,
          count: res.data.count,
          page: action.payload.page,
          isListNext: res.data.isListNext,
        },
      });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


const saga = [
  takeLatest('MY_QA_ANSWER_LIST_GET', myQaAnswerListGet),
];

export default saga;
